<template>
  <div class="item-manager">
    <header class="toolbar">
      <div>
        <h3>Katalog Ürün Yönetimi</h3>
        <p class="subtitle">Katalog ürünlerini oluştur, düzenle ve görsellerini yönet.</p>
      </div>
      <div class="toolbar-actions">
        <button class="ghost" type="button" @click="fetchCategories()">Kategorileri Yenile</button>
        <button class="ghost" type="button" @click="fetchItems()">Ürünleri Yenile</button>
      </div>
    </header>

    <section class="card">
      <div class="card-header">
        <h4>{{ isEdit ? "Ürünü Güncelle" : "Yeni Ürün Ekle" }}</h4>
      </div>

      <form class="form" @submit.prevent="isEdit ? updateItem() : createItem()">
        <div class="grid">
          <label class="field">
            <span class="label">Kategori</span>
            <select v-model.number="selected.cat_id" required>
              <option :value="null" disabled>Seçiniz</option>
              <option v-for="c in categories" :key="c.cat_id" :value="c.cat_id">
                {{ c.name }}
              </option>
            </select>
          </label>

          <label class="field">
            <span class="label">Sıra No</span>
            <input v-model.number="selected.order_no" type="number" min="0" inputmode="numeric" />
          </label>

          <label class="field">
            <span class="label">Başlık</span>
            <input v-model="selected.title" type="text" />
          </label>

          <label class="field">
            <span class="label">İsim <b class="req">*</b></span>
            <input v-model="selected.name" type="text" required />
          </label>

          <label class="field">
            <span class="label">Seri No</span>
            <input v-model="selected.seri_no" type="text" />
          </label>

          <label class="field">
            <span class="label">Alt Ton</span>
            <input v-model="selected.alt_tone" type="text" />
          </label>

          <label class="field">
            <span class="label">Pigment Tipi</span>
            <input v-model="selected.pigment_type" type="text" />
          </label>

          <label class="field col-2">
            <span class="label">Açıklama</span>
            <textarea v-model="selected.description" rows="3"></textarea>
          </label>

          <!-- Görsel alanları -->
          <div class="field">
            <span class="label">Örnek Görsel (sample_img)</span>
            <label class="filelane">
              <input type="file" @change="onFile($event, 'sample_img')" accept="image/*" />
              <div class="filelane-ui">
                <div class="file-icon">🖼️</div>
                <div>
                  <div class="file-title">Dosya seç veya sürükle-bırak</div>
                  <div class="file-hint">PNG, JPG, WEBP</div>
                </div>
              </div>
            </label>
          </div>

          <div class="field">
            <span class="label">Ürün Görseli (product_img)</span>
            <label class="filelane">
              <input type="file" @change="onFile($event, 'product_img')" accept="image/*" />
              <div class="filelane-ui">
                <div class="file-icon">📦</div>
                <div>
                  <div class="file-title">Dosya seç veya sürükle-bırak</div>
                  <div class="file-hint">PNG, JPG, WEBP</div>
                </div>
              </div>
            </label>
          </div>

          <div class="field">
            <span class="label">Renk Görseli (color_img)</span>
            <label class="filelane">
              <input type="file" @change="onFile($event, 'color_img')" accept="image/*" />
              <div class="filelane-ui">
                <div class="file-icon">🎨</div>
                <div>
                  <div class="file-title">Dosya seç veya sürükle-bırak</div>
                  <div class="file-hint">PNG, JPG, WEBP</div>
                </div>
              </div>
            </label>
          </div>
        </div>

        <div class="actions">
          <button class="primary" type="submit">{{ isEdit ? "Güncelle" : "Ekle" }}</button>
          <button v-if="isEdit" class="secondary" type="button" @click="cancelEdit">İptal</button>
          <button v-if="isEdit" class="danger ghost" type="button" @click="resetForm">Formu Temizle</button>
        </div>
      </form>
    </section>

    <section class="card">
      <div class="card-header">
        <h4>Ürünler</h4>
      </div>

      <div class="table-wrap">
        <table class="tbl">
          <thead>
            <tr>
              <th>ID</th>
              <th>Kategori</th>
              <th>Ad</th>
              <th>Seri</th>
              <th>Sıra</th>
              <th>Örnek</th>
              <th>Ürün</th>
              <th>Renk</th>
              <th>Oluşturulma</th>
              <th>İşlem</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="i in items" :key="i.item_id">
              <td>{{ i.item_id }}</td>
              <td>{{ i.category_name || i.cat_id }}</td>
              <td class="truncate">{{ i.name }}</td>
              <td>{{ i.seri_no || "-" }}</td>
              <td>{{ i.order_no ?? "-" }}</td>
              <td>
                <img v-if="i.sample_img" :src="i.sample_img" alt="sample" class="thumb" />
              </td>
              <td>
                <img v-if="i.product_img" :src="i.product_img" alt="product" class="thumb" />
              </td>
              <td>
                <img v-if="i.color_img" :src="i.color_img" alt="color" class="thumb" />
              </td>
              <td>{{ formatDate(i.created_at) }}</td>
              <td class="row-actions">
                <button class="icon-btn" title="Düzenle" @click="editItem(i)">✏️</button>
                <button class="icon-btn danger" title="Sil" @click="deleteItem(i.item_id)">🗑️</button>
              </td>
            </tr>
            <tr v-if="!items.length">
              <td colspan="10" class="empty">Kayıt bulunamadı.</td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "CatalougeItemManager",
  data() {
    return {
      categories: [],
      items: [],
      selected: {
        item_id: null,
        cat_id: null,
        order_no: null,
        title: "",
        name: "",
        seri_no: "",
        alt_tone: "",
        pigment_type: "",
        description: "",
      },
      files: {
        sample_img: null,
        product_img: null,
        color_img: null,
      },
      isEdit: false,
    };
  },
  methods: {
    async fetchCategories() {
      try {
        const res = await axios.get("/admin/promo/catalouge/cats");
        this.categories = res.data.data || [];
      } catch (e) {
        console.error("Kategoriler alınırken hata:", e);
      }
    },
    async fetchItems() {
      try {
        const res = await axios.get("/admin/promo/catalouge/items");
        this.items = res.data.data || [];
      } catch (e) {
        console.error("Ürünler alınırken hata:", e);
      }
    },
    onFile(e, key) {
      const f = e.target.files?.[0] || null;
      this.files[key] = f;
    },
    buildForm() {
      const fd = new FormData();
      fd.append("cat_id", this.selected.cat_id ?? "");
      if (this.selected.order_no !== null && this.selected.order_no !== undefined) fd.append("order_no", this.selected.order_no);
      if (this.selected.title) fd.append("title", this.selected.title);
      fd.append("name", this.selected.name);
      if (this.selected.seri_no) fd.append("seri_no", this.selected.seri_no);
      if (this.selected.alt_tone) fd.append("alt_tone", this.selected.alt_tone);
      if (this.selected.pigment_type) fd.append("pigment_type", this.selected.pigment_type);
      if (this.selected.description) fd.append("description", this.selected.description);

      if (this.files.sample_img) fd.append("sample_img", this.files.sample_img);
      if (this.files.product_img) fd.append("product_img", this.files.product_img);
      if (this.files.color_img) fd.append("color_img", this.files.color_img);
      return fd;
    },
    async createItem() {
      try {
        const fd = this.buildForm();
        await axios.post("/admin/promo/catalouge/item", fd, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        await this.fetchItems();
        this.resetForm();
      } catch (e) {
        console.error("Ürün oluşturulurken hata:", e);
      }
    },
    async updateItem() {
      try {
        const fd = this.buildForm();
        await axios.put(`/admin/promo/catalouge/item/${this.selected.item_id}`, fd, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        await this.fetchItems();
        this.resetForm();
      } catch (e) {
        console.error("Ürün güncellenirken hata:", e);
      }
    },
    async deleteItem(item_id) {
      if (confirm("Bu ürünü silmek istediğinize emin misiniz?")) {
        try {
          await axios.delete(`/admin/promo/catalouge/item/${item_id}`);
          await this.fetchItems();
        } catch (e) {
          console.error("Ürün silinirken hata:", e);
        }
      }
    },
    editItem(i) {
      this.selected = {
        item_id: i.item_id,
        cat_id: i.cat_id,
        order_no: i.order_no,
        title: i.title,
        name: i.name,
        seri_no: i.seri_no,
        alt_tone: i.alt_tone,
        pigment_type: i.pigment_type,
        description: i.description,
      };
      this.files = { sample_img: null, product_img: null, color_img: null };
      this.isEdit = true;
      // Forma scrollda yardımcı
      requestAnimationFrame(() => {
        document.querySelector(".card")?.scrollIntoView({ behavior: "smooth", block: "start" });
      });
    },
    resetForm() {
      this.selected = {
        item_id: null,
        cat_id: null,
        order_no: null,
        title: "",
        name: "",
        seri_no: "",
        alt_tone: "",
        pigment_type: "",
        description: "",
      };
      this.files = { sample_img: null, product_img: null, color_img: null };
      this.isEdit = false;
    },
    cancelEdit() {
      this.resetForm();
    },
    formatDate(d) {
      return d ? new Date(d).toLocaleString() : "-";
    },
  },
  mounted() {
    this.fetchCategories();
    this.fetchItems();
  },
};
</script>

<style scoped>
/* === Dark Tema Değişkenleri === */
:host, .item-manager {
  color-scheme: dark;
}
:root, .item-manager {
  --bg: #0f1115;
  --panel: #151823;
  --panel-2: #1a1f2e;
  --muted: #9aa4b2;
  --text: #e6e9ef;
  --border: #262c3f;
  --accent: #5b8cff; /* mavi-efekt */
  --accent-2: #8a5bff; /* ikincil vurgu */
  --danger: #ff5b73;
  --success: #3ddc97;
  --shadow: 0 10px 25px rgba(0,0,0,.35);
  --radius: 14px;
  --radius-sm: 10px;
  --radius-xs: 8px;
  --pad: 16px;
}

.item-manager {
  background: var(--bg);
  color: var(--text);
  padding: 24px;
  display: grid;
  gap: 24px;
  min-height: 100%;
  font-family: ui-sans-serif, system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial;
}

/* === Toolbar === */
.toolbar {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 16px;
}
.toolbar h3 {
  margin: 0 0 4px;
  font-size: 20px;
  font-weight: 700;
}
.subtitle { margin: 0; color: var(--muted); font-size: 13px; }
.toolbar-actions { display: flex; gap: 8px; }

.ghost {
  background: transparent;
  border: 1px solid var(--border);
  color: var(--text);
  padding: 8px 12px;
  border-radius: var(--radius-xs);
  cursor: pointer;
  transition: border-color .2s, background .2s, transform .06s;
}
.ghost:hover { border-color: var(--accent); background: rgba(91,140,255,.08); }
.ghost:active { transform: translateY(1px); }

/* === Kart === */
.card {
  background: linear-gradient(180deg, var(--panel), var(--panel-2));
  border: 1px solid var(--border);
  border-radius: var(--radius);
  box-shadow: var(--shadow);
}
.card-header {
  padding: 14px 18px;
  border-bottom: 1px solid var(--border);
}
.card-header h4 { margin: 0; font-size: 16px; font-weight: 700; }

/* === Form === */
.form { padding: 18px; }
.grid {
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  gap: 14px;
}
.field { grid-column: span 6; display: grid; gap: 8px; }
.col-2 { grid-column: span 12; }

.label {
  font-size: 12px;
  color: var(--muted);
  letter-spacing: .2px;
}
.req { color: var(--danger); }

input[type="text"],
input[type="number"],
select,
textarea {
  width: 100%;
  padding: 10px 12px;
  background: #0d0f16;
  color: var(--text);
  border: 1px solid var(--border);
  border-radius: var(--radius-xs);
  outline: none;
  transition: border-color .2s, box-shadow .2s, background .2s;
}
textarea { resize: vertical; }
input::placeholder, textarea::placeholder { color: #717a8a; }

input:focus, select:focus, textarea:focus {
  border-color: var(--accent);
  box-shadow: 0 0 0 3px rgba(91,140,255,.15);
}

/* === File lane === */
.filelane {
  position: relative;
  display: block;
  border: 1px dashed var(--border);
  border-radius: var(--radius-xs);
  background: #0b0d13;
  padding: 10px;
  cursor: pointer;
  transition: border-color .2s, background .2s;
}
.filelane:hover { border-color: var(--accent); background: rgba(91,140,255,.05); }
.filelane input[type="file"] {
  /* gerçek input gizli */
  position: absolute; inset: 0; opacity: 0; cursor: pointer;
}
.filelane-ui {
  display: flex; align-items: center; gap: 12px;
}
.file-icon { font-size: 18px; }
.file-title { font-size: 13px; }
.file-hint { font-size: 11px; color: var(--muted); }

/* === Actions === */
.actions {
  margin-top: 10px;
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}
button.primary {
  background: linear-gradient(180deg, var(--accent), #3a68ff);
  color: white;
  border: none;
  padding: 10px 16px;
  border-radius: var(--radius-xs);
  cursor: pointer;
  transition: transform .06s, filter .2s;
}
button.primary:hover { filter: brightness(1.05); }
button.primary:active { transform: translateY(1px); }

button.secondary {
  background: #0d1020;
  color: var(--text);
  border: 1px solid var(--border);
  padding: 10px 16px;
  border-radius: var(--radius-xs);
  cursor: pointer;
}
button.danger {
  border: 1px solid transparent;
  background: rgba(255,91,115,.12);
  color: #ff9aa8;
}
button.danger.ghost {
  background: transparent;
  border-color: rgba(255,91,115,.35);
  color: #ff9aa8;
}
button.secondary:hover { border-color: var(--accent); }
button.danger:hover { background: rgba(255,91,115,.18); }

/* === Tablo === */
.table-wrap {
  overflow: auto;
  border-top-left-radius: var(--radius);
  border-top-right-radius: var(--radius);
}
.tbl {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
}
.tbl thead th {
  position: sticky; top: 0;
  background: #0d1020;
  color: var(--muted);
  font-weight: 600;
  text-align: left;
  font-size: 12px;
  letter-spacing: .2px;
  border-bottom: 1px solid var(--border);
  padding: 10px 12px;
  z-index: 1;
}
.tbl tbody td {
  border-bottom: 1px solid var(--border);
  padding: 12px;
  vertical-align: middle;
  font-size: 13px;
}
.tbl tbody tr:hover {
  background: rgba(91,140,255,.05);
}
.truncate {
  max-width: 220px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.row-actions { display: flex; gap: 6px; }
.icon-btn {
  background: #0d1020;
  border: 1px solid var(--border);
  border-radius: 8px;
  padding: 6px 8px;
  cursor: pointer;
  transition: border-color .2s, transform .06s, background .2s;
}
.icon-btn:hover { border-color: var(--accent); background: rgba(91,140,255,.08); }
.icon-btn.danger:hover { border-color: var(--danger); background: rgba(255,91,115,.12); }
.empty { text-align: center; color: var(--muted); padding: 24px; }

/* === Görseller === */
.thumb {
  width: 56px; height: 56px;
  object-fit: cover;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: #0b0d13;
}

/* === Responsive === */
@media (max-width: 1100px) {
  .field { grid-column: span 12; }
}
@media (max-width: 640px) {
  .toolbar { flex-direction: column; align-items: stretch; }
  .toolbar-actions { justify-content: flex-start; }
  .tbl thead { display: none; }
  .tbl, .tbl tbody, .tbl tr, .tbl td { display: block; width: 100%; }
  .tbl tr { border: 1px solid var(--border); border-radius: 12px; margin-bottom: 10px; overflow: hidden; }
  .tbl tbody td { display: flex; justify-content: space-between; gap: 12px; }
  .tbl tbody td::before {
    content: attr(data-th);
    color: var(--muted);
  }
}
</style>
